export default {"src":"/_next/static/media/spinner.c161f269.gif","height":92,"width":92,"blurWidth":0,"blurHeight":0};